import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../navigators/NavigationProp';

import Edit, {
  DispatchProps,
  StateProps,
} from '../../../components/projects/story_images/Edit';

import AppState from '../../../reducers/AppState';

import updateStory, {
  Params as StoryUpdateParams,
} from '../../../actions/stories/update';
import updateStoryForm, {
  Params as StoryFormUpdateParams,
} from '../../../actions/story_forms/update';
import createCoverImageForm, {
  Params as CoverImageFormCreateParams,
} from '../../../actions/cover_image_forms/create';
import updateCoverImageForm, {
  Params as CoverImageFormUpdateParams,
} from '../../../actions/cover_image_forms/update';

interface Props {
  navigation: NavigationProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation} = props;
  const {forms} = state;
  const storyForm = forms.storyForm;
  const coverImageForm =
    forms.coverImageForm?.type === 'image' ? forms.coverImageForm : null;
  return {
    navigation,
    storyForm,
    coverImageForm,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    updateStory: (id: number, params: StoryUpdateParams) =>
      dispatch(updateStory(id, params)),
    updateStoryForm: (params: StoryFormUpdateParams) =>
      dispatch(updateStoryForm(params)),
    createCoverImageForm: (params: CoverImageFormCreateParams) =>
      dispatch(createCoverImageForm(params)),
    updateCoverImageForm: (params: CoverImageFormUpdateParams) =>
      dispatch(updateCoverImageForm(params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(Edit);
